import { createOutlet } from '../outlets';
export function registerNamespaceStore(innerStore, namespace, storeCache, config) {
    var enhancer = config.enhancer, getInitialState = config.getInitialState, reducer = config.reducer;
    var createStore = function (reducer, preloadedState) {
        innerStore.register(namespace, reducer, preloadedState);
        return {
            dispatch: function (action) { return innerStore.dispatch(namespace, action); },
            getState: function () { return innerStore.getState()[namespace]; },
        };
    };
    if (enhancer) {
        createStore = enhancer(createStore);
    }
    // Only reset the state to the initial state if it wasn't already
    // hydrated with something else.
    var innerStoreState = innerStore.getState();
    var preloadedState = namespace in innerStoreState
        ? innerStoreState[namespace]
        : getInitialState && getInitialState();
    var _a = createStore(reducer, preloadedState), dispatch = _a.dispatch, getState = _a.getState;
    storeCache.register(namespace, getState, config);
    return [
        Object.assign(createOutlet({
            getCurrentValue: function () {
                var cache = storeCache.get(namespace);
                if (cache.error) {
                    throw cache.error;
                }
                // Let createOutlet do the work of throwing a promise
                return cache.value;
            },
            hasCurrentValue: function () {
                return storeCache.get(namespace).hasCurrentValue;
            },
            subscribe: function (callback) {
                // Check that state has actually changed before asking the outlet to
                // recompute hasCurrentValue, value and error
                var lastState = getState();
                return innerStore.subscribe(function () {
                    var state = getState();
                    if (lastState !== state) {
                        lastState = state;
                        callback();
                    }
                });
            },
        }), { getState: getState }),
        dispatch,
    ];
}
//# sourceMappingURL=NamespaceStore.js.map